import React, { useEffect, useState } from "react"
import { Table, Row, Col, Input, Modal, Form, Label } from "reactstrap"
import { useNavigate } from "react-router-dom"
import { useMemo } from "react"
import { useTable, usePagination, useGlobalFilter } from "react-table"
import Select from "react-select"

// common
import Pagination from "components/Common/Pagination"
import Loader from "pages/Separate/Loader"
import {
  fetchNodeData,
  FetchNodeDeleteData,
  FetchNodePostData,
  FetchNodePutData,
  fetchData,
} from "utils/common-fetchData"
import Swal from "sweetalert2"
import secureLocalStorage from "react-secure-storage"
import { colourStyles } from "utils/common-options"
import NewPagination from "components/Common/Newpagination"

function TableContainer({
  columns,
  data,
  setLoading,
  getData,
  colourStyles,
  currencyOptions,
}) {
  const [status, setStatus] = useState(false)
  const [fixedContent, setFixedContent] = useState(false)
  const [packageName, setPackageName] = useState("")
  const [selectedServices, setSelectedServices] = useState([])
  const [services, setServices] = useState("")
  const [totalPrice, setTotalPrice] = useState(0)
  const [serviceOptions, setServiceOptions] = useState([])
  const [currency, setCurrency] = useState(null)

  document.addEventListener("scroll", () => {
    if (window.scrollY > 160) {
      setFixedContent(true)
    } else {
      setFixedContent(false)
    }
  })

  const fetchServices = async () => {
    const response = await fetchNodeData(
      setLoading,
      "hostingService/service/get",
      secureLocalStorage?.getItem("auth_token")
    )
    const options = response.data.map(item => ({
      value: item.id,
      label: item.service_name,
      price: item.price,
    }))
    setServiceOptions(options)
  }

  useEffect(() => {
    fetchServices()
  }, [])

  const addHostingPackage = async e => {
    e.preventDefault()

    if (!packageName || !services) {
      Swal.fire({
        icon: "warning",
        text: "Please fill all required fields!",
      })
      return
    }

    const payload = {
      package_name: packageName || "",
      service: services || "",
      currency: currency?.value || "",
       currencySymbol: currency?.symbol,
    }

    const response = await FetchNodePostData(
      setLoading,
      "hostingPackage/package/add",
      secureLocalStorage.getItem("auth_token"),
      payload
    )

    if (response?.data.success) {
      getData()
      Swal.fire({
        icon: "success",
        text: "Package Added Successfully",
        showConfirmButton: true,
      })
      setStatus(false)
      setPackageName("")
      setSelectedServices([])
      setServices("")
      setTotalPrice(0)
      setCurrency(null)
    } else {
      Swal.fire({
        icon: "error",
        text: res?.data?.message || "Failed to add package",
      })
    }
  }

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    state,
    previousPage,
    nextPage,
    canPreviousPage,
    canNextPage,
    gotoPage,
    setPageSize,
    pageOptions,
    setGlobalFilter,
    pageCount,
    prepareRow,
    setData,
  } = useTable(
    {
      columns,
      data,
      currencyOptions,
    },
    useGlobalFilter,
    usePagination
  )

  const { pageIndex, pageSize, globalFilter } = state

  const navigate = useNavigate()

  return (
    <div className="px-2">
      <div
        className={`flex-column fixed-buttons ${
          fixedContent ? "d-flex" : "d-none"
        }`}
      >
        <button
          onClick={() => {
            setStatus(true)
          }}
          className="btn btn-purple border-radius fix-btn"
        >
          <i className="fas fa-plus me-2"></i>
          <span>Package</span>
        </button>
        <a
          onClick={() => navigate(-1)}
          className="btn btn-red border-radius fix-btn"
        >
          <i className="dripicons-cross me-2 icon-center"></i>
          <span>Cancel</span>
        </a>
      </div>

      <Row className="mb-2">
        <Col lg={2}>
          <select
            className="border-radius form-select"
            style={{ width: "100px" }}
            value={pageSize}
            onChange={e => setPageSize(e.target.value)}
          >
            {[10, 20, 30, 40, 50].map(pageSize => (
              <option key={pageSize} value={pageSize}>
                Show {pageSize}
              </option>
            ))}
          </select>
        </Col>
        <Col className="d-flex justify-content-end">
          <div className="me-4">
            <div className="search-box me-xxl-2 my-xxl-0 d-inline-block">
              <div className="position-relative">
                <label htmlFor="search-bar-0" className="search-label">
                  <span id="search-bar-0-label" className="sr-only">
                    Search this table
                  </span>
                  <input
                    onChange={e => setGlobalFilter(e.target.value)}
                    id="search-bar-0"
                    type="text"
                    className="border-radius form-control rounded h-100"
                    placeholder={` Search...`}
                    value={globalFilter || ""}
                  />
                </label>
                <i className="bx bx-search-alt search-icon"></i>
              </div>
            </div>
          </div>
          <div>
            <a
              className="border-radius btn btn-purple"
              onClick={() => {
                fetchServices()
                setStatus(true)
              }}
            >
              <i className="fas fa-plus me-2 icon-size"></i>Add Package
            </a>
            <a
              className="border-radius btn text-white ms-md-2 btn-red"
              onClick={() => navigate(-1)}
            >
              <i className="dripicons-cross me-2 icon-center"></i>Cancel
            </a>
          </div>
        </Col>
      </Row>
      <Table className="table table-bordered mt-4" {...getTableProps()}>
        <thead className={`${fixedContent ? "fixed-setting-header" : ""}`}>
          {headerGroups.map((headerGroup, i) => (
            <tr key={i} {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map((column, index) => (
                <th
                  key={index}
                  className={`col-md-${index === 1 || index === 2 ? "4" : "2"}`}
                  {...column.getHeaderProps()}
                >
                  {column.render("Header")}
                </th>
              ))}
            </tr>
          ))}
        </thead>

        <tbody {...getTableBodyProps()}>
          {page.map((row, i) => {
            prepareRow(row)
            return (
              <tr className="row-hover" {...row.getRowProps()} key={i}>
                {row.cells.map((cell, index) => {
                  return (
                    <td
                      className={`col-md-${
                        index === 1 || index === 2 ? "4" : "2"
                      }`}
                      key={index}
                      {...cell.getCellProps()}
                    >
                      {cell.render("Cell")}
                    </td>
                  )
                })}
              </tr>
            )
          })}
        </tbody>
      </Table>

      <Row className="justify-content-md-end justify-content-center align-items-center">
        <NewPagination
          gotoPage={gotoPage}
          canPreviousPage={canPreviousPage}
          previousPage={previousPage}
          canNextPage={canNextPage}
          pageIndex={pageIndex}
          pageOptions={pageOptions}
          pageSize={pageSize}
          page={page}
          data={data}
          nextPage={nextPage}
        />
      </Row>

      <Modal isOpen={status} size="sm" className="bd-custom-md-2" centered>
        <div className="modal-header">
          <h5 className="modal-title mt-0">Add Package</h5>
          <button
            type="button"
            onClick={() => {
              setStatus(false)
              setPackageName("")
              setSelectedServices([])
              setServices("")
              setTotalPrice(0)
              setCurrency(null)
            }}
            className="btn-modal-close"
          >
            <span aria-hidden="true" className="btn-modal-span">
              &times;
            </span>
          </button>
        </div>
        <div className="modal-body">
          <Form className="row1" onSubmit={addHostingPackage}>
            <div className="mb-3 col-md-12">
              <Label htmlFor="formrow-firstname-Input">
                Package Name<span className="text-danger"> *</span>
              </Label>
              <Input
                type="text"
                className="form-control"
                id="formrow-firstname-Input"
                placeholder="Enter Package Name"
                value={packageName}
                onChange={e => setPackageName(e.target.value)}
                required
              />
            </div>
            <div className="mb-3 col-md-12">
              <Label htmlFor="formrow-firstname-Input">
                Select Service<span className="text-danger"> *</span>
              </Label>
              <Select
                placeholder="Select Service"
                className="basic-multi-select border-radius"
                classNamePrefix="select"
                styles={colourStyles}
                options={serviceOptions}
                isMulti={true}
                required
                value={selectedServices}
                onChange={selected => {
                  if (!selected) {
                    setSelectedServices([])
                    setServices("")
                    setTotalPrice(0)
                    return
                  }

                  setSelectedServices(selected)
                  const ids = selected.map(item => item.value)
                  const idsString = ids.join(",")
                  const sum = selected.reduce(
                    (acc, item) => acc + Number(item.price || 0),
                    0
                  )
                  setServices(idsString)
                  setTotalPrice(sum)
                }}
              />
            </div>
            <div className="row">
              <div className="mb-3 col-md-6">
                <label>Currency</label>
                <Select
                  placeholder="Select Currency"
                  className="basic-multi-select"
                  classNamePrefix="select"
                  styles={{
                    ...colourStyles,
                    container: base => ({ ...base, width: "100%" }),
                  }}
                  options={currencyOptions}
                  value={currency}
                  onChange={e => setCurrency(e)}
                      formatOptionLabel={option => (
      <div>
        {option.label} {option.symbol}
      </div>
    )}
                />
              </div>

              <div className="mb-3 col-md-6">
                <Label htmlFor="formrow-price-Input">Price</Label>
                <Input
                  type="text"
                  className="form-control"
                  id="formrow-price-Input"
                  placeholder="100"
                  value={totalPrice}
                  disabled
                />
              </div>
            </div>
            <div className="mt-20">
              <button className="border-radius btn btn-purple">Submit</button>
            </div>
          </Form>
        </div>
      </Modal>
    </div>
  )
}

const HostingPackage = () => {
  const [loading, setLoading] = useState(false)
  const [data, setData] = useState()
  const [editData, setEditData] = useState({})
  const [serviceOptions, setServiceOptions] = useState([])
  const [services, setServices] = useState("")
  const [totalPrice, setTotalPrice] = useState(0)
  const [edit_status, setEditStatus] = useState(false)
  const [packageName, setPackageName] = useState("")
  const [editId, setEditId] = useState(null)
  const [selectedServices, setSelectedServices] = useState([])
  const [currencyOptions, setCurrencyOptions] = useState([])
  const [currency, setCurrency] = useState(null)

  // <-- ADD THIS USEEFFECT FOR PREFILLING CURRENCY -->
  useEffect(() => {
    if (editData.currency && currencyOptions.length > 0) {
      const selectedOption = currencyOptions.find(c => c.value === editData.currency)
      if (selectedOption) {
        setCurrency(selectedOption)
      }
    }
  }, [editData, currencyOptions])
  // <-- END OF USEEFFECT -->

  useEffect(() => {
    ;(async () => {
      const response = await fetchData(
        setLoading,
        "currency",
        secureLocalStorage?.getItem("auth_token")
      )
      if (response?.success) {
        const options = response?.data?.currency?.map(c => ({
          label: c.currency,
          value: c.currency,
          symbol : c.symbol
        }))
        setCurrencyOptions(options)
      }
    })()
  }, [])

  const columns = useMemo(
    () => [
      {
        Header: "ID",
        accessor: "id",
        className: "id-width",
      },
      {
        Header: "Package Name",
        accessor: "package_name",
      },
      {
        Header: "Services",
        accessor: "service_names",
      },
      {
        Header: "Action",
        accessor: "action",
        className: "action-width",
        Cell: cellProps => {
          return (
            <div>
              <a
                onClick={() => {
                  EditPackage(cellProps?.row?.original)
                }}
                className="btn btn-sm me-1 btn-outline-secondary"
              >
                <i className="fas fa-pencil-alt"></i>
              </a>
              <a
                className="btn btn-sm  btn-danger"
                onClick={() => {
                  DeletePackage(cellProps?.row?.original?.id)
                }}
              >
                <i className="fas fa-trash-alt"></i>
              </a>
            </div>
          )
        },
      },
    ],
    []
  )
  const colourStyles = {
    menuList: styles => ({
      ...styles,
      background: "white",
    }),
    menu: base => ({
      ...base,
      zIndex: 50,
    }),
  }

  const EditPackage = async data => {
    setEditId(data.id)
    const response = await fetchNodeData(
      setLoading,
      "hostingService/service/get",
      secureLocalStorage?.getItem("auth_token")
    )

    const options = response.data.map(item => ({
      value: item.id,
      label: item.service_name,
      price: item.price,
      currency: currency?.value || "",
    }))

    setServiceOptions(options)

    setEditData(data)
    setPackageName(data.package_name)

    if (data.services) {
      const selectedIds = data.services.split(",").map(id => parseInt(id))
      const selectedOptions = options.filter(opt =>
        selectedIds.includes(opt.value)
      )

      setSelectedServices(selectedOptions) // 👈 store objects
      setServices(selectedIds.join(","))

      const sum = selectedOptions.reduce(
        (acc, item) => acc + Number(item.price || 0),
        0
      )
      setTotalPrice(sum)
    } else {
      setSelectedServices([])
      setServices("")
      setTotalPrice(0)
    }

    if (data.currency) {
     const selectedOption = currencyOptions.find(c => c.value === data.currency)
  setCurrency(selectedOption || null) // store full object with symbol
    } else {
      setCurrency(null)
    }

    setEditStatus(true)
  }

  const DeletePackage = async id => {
    Swal.fire({
      icon: "warning",
      text: "Are you sure to delete?",
      showCancelButton: true,
    }).then(async result => {
      if (result.isConfirmed) {
        const response = await FetchNodeDeleteData(
          setLoading,
          "hostingPackage/package/delete",
          id
        )
        if (response?.data.success) {
          getData()
          Swal.fire({ icon: "success", text: "Package Deleted Successfully" })
        } else {
          Swal.fire({
            icon: "error",
            text: response.data?.message || "Failed to delete package",
          })
        }
      }
    })
  }

  const getData = async () => {
    const response = await fetchNodeData(
      setLoading,
      "hostingPackage/package/get",
      secureLocalStorage?.getItem("auth_token")
    )
    setData(response.data)
  }

  useEffect(() => {
    getData()
  }, [])

  const editHostingPackage = async e => {
    e.preventDefault()

    if (!packageName || !services) {
      Swal.fire({
        icon: "warning",
        text: "Please fill all required fields!",
      })
      return
    }

    const res = await FetchNodePutData(
      setLoading,
      `hostingPackage/package/edit`,
      editId,
      {
        package_name: packageName,
        service: services,
        currency: currency.value,
        symbol :currency?.symbol,
      }
    )
    if (res?.status == 200) {
      Swal.fire({
        icon: "success",
        text: "Hosting Package Edited Successfully",
        showConfirmButton: true,
      })
      getData()
      setEditStatus(false)
      setPackageName("")
      setServices("")
      setTotalPrice(0)
      setSelectedServices([])
      setCurrency(null)
    }
  }

  return (
    <div>
      {loading && <Loader />}
      <Row>
        <Col lg={12} className="p-0">
          <div className="responsive-table">
            <TableContainer
              columns={columns}
              data={data || []}
              setLoading={setLoading}
              getData={getData}
              currencyOptions={currencyOptions}
              colourStyles={colourStyles}
            />
          </div>
        </Col>

        <Modal
          isOpen={edit_status}
          size="sm"
          className="bd-custom-md-2"
          centered
        >
          <div className="modal-header">
            <h5 className="modal-title mt-0">Edit Package</h5>
            <button
              type="button"
              onClick={() => {
                setEditStatus(false)
              }}
              className="btn-modal-close"
            >
              <span aria-hidden="true" className="btn-modal-span">
                &times;
              </span>
            </button>
          </div>
          <div className="modal-body">
            <Form className="row1" onSubmit={editHostingPackage}>
              <div className="mb-3 col-md-12">
                <Label htmlFor="formrow-firstname-Input">
                  Package Name<span className="text-danger"> *</span>
                </Label>
                <Input
                  type="text"
                  className="form-control"
                  id="formrow-firstname-Input"
                  placeholder="Enter Package Name"
                  value={packageName}
                  onChange={e => setPackageName(e.target.value)}
                  required
                />
              </div>

              <div className="mb-3 col-md-12">
                <Label htmlFor="formrow-firstname-Input">
                  Select Service<span className="text-danger"> *</span>
                </Label>
                <Select
                  placeholder="Select Service"
                  className="basic-multi-select border-radius"
                  classNamePrefix="select"
                  styles={colourStyles}
                  options={serviceOptions}
                  isMulti={true}
                  required
                  value={selectedServices}
                  onChange={selected => {
                    if (!selected) {
                      setSelectedServices([])
                      setServices("")
                      setTotalPrice(0)
                      return
                    }

                    setSelectedServices(selected)

                    // Extract ids
                    const ids = selected.map(item => item.value)
                    const idsString = ids.join(",")

                    // Calculate total price
                    const sum = selected.reduce(
                      (acc, item) => acc + Number(item.price || 0),
                      0
                    )

                    setServices(idsString)
                    setTotalPrice(sum)
                  }}
                />
              </div>
              <div className="row">
                <div className="mb-3 col-md-6">
                  <label>Currency</label>
<Select
  placeholder="Select Currency"
  className="basic-multi-select"
  classNamePrefix="select"
  styles={{
    ...colourStyles,
    container: base => ({ ...base, width: "100%" }),
  }}
  options={currencyOptions}
  value={currency}
  onChange={e => setCurrency(e)}
  formatOptionLabel={option => (
    <div>
      {option.label} {option.symbol}
    </div>
  )}
/>
                </div>

                <div className="mb-3 col-md-6">
                  <Label htmlFor="formrow-price-Input">Price</Label>
                  <Input
                    type="text"
                    className="form-control"
                    id="formrow-price-Input"
                    placeholder="100"
                  value={currency ? `${totalPrice}` : totalPrice}
                    disabled
                  />
                </div>
              </div>

              <div className="mt-20">
                <button className="border-radius btn btn-purple">Submit</button>
              </div>
            </Form>
          </div>
        </Modal>
      </Row>
    </div>
  )
}

export default HostingPackage
